var map = {
	"./apps/Vue3-FastAPI-WebApp-template/meta.json": 9084,
	"./apps/dailybildi/meta.json": 9722,
	"./apps/debiai/meta.json": 2943,
	"./apps/embeducation/meta.json": 5189,
	"./apps/factorio-blueprint-analyser/meta.json": 7422,
	"./apps/murder-gpt/meta.json": 9274,
	"./apps/pixelation/meta.json": 1496,
	"./games/a-bouncy-game/meta.json": 5477,
	"./games/hedgehog-against-the-apocalypse/meta.json": 1641,
	"./games/pernios-steps/meta.json": 5006,
	"./games/survaillant/meta.json": 5621,
	"./games/tumbleweed/meta.json": 9822,
	"./other/melocussion/meta.json": 7888,
	"./other/percusition/meta.json": 4176,
	"./tools/ecological-project-evaluator/meta.json": 5984,
	"./tools/ecological-quiz/meta.json": 4030,
	"./tools/epepep/meta.json": 8499,
	"./tools/residence-optimizer/meta.json": 2202,
	"./tools/vocal-range-viewer/meta.json": 5370
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7733;